import { OBJECTION_STATUS_LABELS, type ObjectionStatus, type OpportunityObjection } from '@lia/contracts';
import { formatDateTime } from '../../lib/format.js';
import { StatusBadge, type StatusTone } from '../primitives/badge.js';

// Setter §09.4: structured objections of an opportunity as LIA recorded them (category, the prospect's words, status,
// the approved answer and its source). Status is always in words, never color only.

export const OBJECTION_STATUS_TONE: Record<ObjectionStatus, StatusTone> = { open: 'warning', addressed: 'info', resolved: 'success' };

export function ObjectionStatusBadge({ status }: { status: ObjectionStatus }) {
  return <StatusBadge tone={OBJECTION_STATUS_TONE[status]}>{OBJECTION_STATUS_LABELS[status]}</StatusBadge>;
}

const CHANNEL = { whatsapp: 'WhatsApp', voice: 'Llamada' } as const;

export function ObjectionList({ objections, timeZone }: { objections: readonly OpportunityObjection[]; timeZone: string }) {
  if (!objections.length) return <p className="text-body text-text-secondary">No hay objeciones registradas para esta oportunidad.</p>;
  return (
    <ul className="grid gap-2">
      {objections.map((o) => (
        <li key={o.id} className="grid gap-1 rounded-md border border-border-subtle p-3">
          <span className="flex flex-wrap items-center gap-2">
            <span className="text-body font-medium text-text-primary">{o.categoryLabel}</span>
            <ObjectionStatusBadge status={o.status} />
          </span>
          <span className="break-words text-body text-text-primary">{`«${o.prospectWords}»`}</span>
          {o.handledWith ? <span className="break-words text-meta text-text-secondary">{`Respuesta aprobada: ${o.handledWith}${o.knowledgeRef ? ` (fuente: ${o.knowledgeRef})` : ''}`}</span> : null}
          <span className="text-meta text-text-secondary">{`${CHANNEL[o.channel]} · ${formatDateTime(o.createdAt, timeZone)}${o.resolvedAt ? ` · resuelta ${formatDateTime(o.resolvedAt, timeZone)}` : ''}`}</span>
        </li>
      ))}
    </ul>
  );
}
